import React from "react";
import { SimpleField } from "@Components/FormFields/SimpleField";
import RadioGroup from "@overrides_venia/venia-ui/components/RadioGroup/radioGroup";
export var GenderField = _ref => {
  var {
    showLabel,
    required = false,
    showInvalid
  } = _ref;
  return /*#__PURE__*/React.createElement(SimpleField, {
    showLabel: showLabel,
    label: "gender",
    name: "gender",
    required: required,
    showInvalid: showInvalid,
    children: /*#__PURE__*/React.createElement(RadioGroup, {
      isVertical: false,
      field: "gender",
      items: [{
        label: "M",
        value: 1
      }, {
        label: "F",
        value: 2
      }, {
        label: "Non binario",
        value: 3
      }],
      required: true
    })
  });
};